import styled, { css } from 'styled-components';

export const Ul = styled.ul<{
  hasError?: boolean;
  isHeader?: boolean;
}>`
  align-items: center;
  border: 1px solid #d4d4d5;
  display: flex;
  list-style: none;
  margin: 0;
  min-height: 65px;
  padding: 0 0 0 16px;
  width: 100%;

  ${({ hasError }) =>
    hasError &&
    css`
      background-color: #e9e9e9;
      color: #999999;
      min-height: 40px;
      line-height: 40px;
    `}
  ${({ isHeader }) =>
    isHeader &&
    css`
      background-color: #fff6f5;
    `};

  &:nth-child(n + 2) {
    border-top-width: 0;
  }
`;

export const Li = styled.li<{ narrowMargin?: boolean; width: string }>`
  font-size: 12px;
  text-align: left;
  word-break: break-all;

  margin-left: ${({ narrowMargin }) => (narrowMargin ? '8' : '24')}px;
  width: ${({ width }) => width}px;

  &:first-child {
    margin-left: 0;
  }
`;

export const A = styled.a`
  cursor: pointer;
`;
